export default __webpack_public_path__ + "static/media/daedarus.afc0387c.png";